import React, { memo } from 'react'
import { DatePicker } from 'components/forms/DatePicker'
import moment from 'moment'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import FORMATS from 'constants/datetime'

interface IDateProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  error?: string
}

export const Date = memo<IDateProps>(({ error, onChange, value }) => {
  const { endDate, startDate } = value
  const onChangeDate = (e: string[], type: string) => {
    const key = `${type}Date`
    if (e[0]) {
      onChange({ [key]: moment(e[0]).format(FORMATS.yearFirst) })
    }
  }
  const onChangeStartDate = (e: string[]) => onChangeDate(e, 'start')
  const onChangeEndDate = (e: string[]) => onChangeDate(e, 'end')

  return (
    <>
      <div className='col-md-6 col-xs-4'>
        <label htmlFor='modal-start-date'>Start Date</label>
        <DatePicker
          date={startDate}
          placeholder='Date'
          id='modal-start-date'
          dataTest='modal-start-date'
          onDateChange={onChangeStartDate}
          required
          validationMessage={error}
          invalid={!!error}
        />
      </div>
      <div className='col-md-6 col-xs-4'>
        <label htmlFor='modal-end-date'>End Date</label>
        <DatePicker
          date={endDate}
          placeholder='Date'
          id='modal-end-date'
          dataTest='modal-end-date'
          onDateChange={onChangeEndDate}
          minDate={startDate ? moment(startDate, FORMATS.yearFirst).toDate() : ''}
        />
      </div>
    </>
  )
})
